import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './Operations.css';

function Putaway() {
  const { sku } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [quantity, setQuantity] = useState('');
  const [binCode, setBinCode] = useState('');
  const [suggestedBin, setSuggestedBin] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Get expected quantity from URL params or state
  const queryParams = new URLSearchParams(location.search);
  const expectedQty = queryParams.get('qty') || location.state?.quantity || '';

  useEffect(() => {
    fetchSuggestedBin();
    // Pre-fill quantity if provided
    if (expectedQty) {
      setQuantity(expectedQty);
    }
  }, [sku, expectedQty]);

  const fetchSuggestedBin = async () => {
    try {
      const response = await axios.get(`/api/ops/putaway/${sku}`);
      if (response.data.suggested_bin) {
        setSuggestedBin(response.data.suggested_bin);
        setBinCode(response.data.suggested_bin);
      }
    } catch (error) {
      console.error('Failed to fetch suggested bin:', error);
    }
  };

  const handlePutaway = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post('/api/ops/putaway', {
        sku,
        bin_code: binCode,
        quantity: parseInt(quantity),
        user: 'Mobile User' // In production, get from auth
      });

      alert('Putaway completed successfully!');
      navigate(`/ops/${sku}/inventory`);
    } catch (error) {
      setError(error.response?.data?.error || 'Putaway failed');
      setLoading(false);
    }
  };

  return (
    <div className="ops-page">
      <div className="ops-page-header">
        <Link to={`/ops/${sku}`} className="back-button">← Back</Link>
        <h1>Putaway</h1>
        <div className="sku-label">{sku}</div>
      </div>

      <form onSubmit={handlePutaway} className="putaway-form">
        {error && <div className="error-message">{error}</div>}

        {expectedQty && (
          <div className="expected-putaway">
            <div className="expected-label">Expected Putaway Quantity:</div>
            <div className="expected-value">{expectedQty} units</div>
          </div>
        )}

        {suggestedBin && (
          <div className="suggested-bin">
            <div className="suggestion-label">Suggested Bin:</div>
            <div className="suggestion-value">{suggestedBin}</div>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="quantity">Quantity to Putaway</label>
          <input
            type="number"
            id="quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="1"
            placeholder={expectedQty ? `Expected: ${expectedQty}` : "Enter quantity"}
            required
            className="form-control form-control-large"
            autoFocus={!expectedQty}
          />
          {expectedQty && quantity && quantity !== expectedQty && (
            <small className="form-warning">
              ⚠️ Entered quantity ({quantity}) differs from expected ({expectedQty})
            </small>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="binCode">Bin Location</label>
          <input
            type="text"
            id="binCode"
            value={binCode}
            onChange={(e) => setBinCode(e.target.value.toUpperCase())}
            placeholder="Scan or enter bin code"
            required
            className="form-control form-control-large"
          />
          <small className="form-help">
            Format: A-01-01 (Zone-Aisle-Position)
          </small>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="submit-button submit-button-large"
        >
          {loading ? 'Processing...' : 'Complete Putaway'}
        </button>

        <div className="quick-actions">
          <button
            type="button"
            onClick={() => setBinCode('RECEIVING')}
            className="quick-action-btn"
          >
            Receiving
          </button>
          <button
            type="button"
            onClick={() => setBinCode('STAGING')}
            className="quick-action-btn"
          >
            Staging
          </button>
        </div>
      </form>
    </div>
  );
}

export default Putaway;